export default __webpack_public_path__ + "static/media/logo.d95219e1.png";